import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const ATTENTION_DASHBOARD_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('ATTENTION_DASHBOARD');
export const ATTENTION_DASHBOARD_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	ATTENTION_DASHBOARD_CRUD_ACTION_CONSTANTS
);
